import isEmpty from 'lodash.isempty';
import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';

const EnrolleeModal = ({ isOpen, enrollee = {}, onClose, onAddEnrollee }) => {
	const modalRef = useRef();
	const [medUniqId, setMedUniqId] = useState('');
	const [firstName, setFirstName] = useState('');
	const [lastName, setLastName] = useState('');
	const [dob, setDob] = useState('');
	const [sex, setSex] = useState('');
	const [mobileNumber, setMobileNumber] = useState('');

	useEffect(() => {
		if (isOpen) {
			modalRef.current.showModal();
		} else {
			modalRef.current.close();
			setMedUniqId('');
			setFirstName('');
			setLastName('');
			setDob('');
			setSex('');
			setMobileNumber('');
		}
	}, [isOpen]);

	const handleAddEnrollee = (e) => {
		e.preventDefault();
		const [year, month, day] = dob.split('-');
		const newEnrollee = {
			medicaid_unique_id: medUniqId,
			first_name: firstName,
			last_name: lastName,
			dob: `${month}/${day}/${year}`,
			sex,
			mobile_number: mobileNumber,
		};
		onAddEnrollee(newEnrollee);
	};

	return (
		<dialog id="invoice-dialog" className="modal modal-top" ref={modalRef}>
			<div className="modal-box">
				<h3>{isEmpty(enrollee) ? 'Add Enrollee' : 'Enrollee Details'}</h3>
				<div className="grid grid-cols-6 gap-4">
					{isEmpty(enrollee) ? (
						<>
							<div className="form-control">
								<label className="label">Medicaid Unique ID</label>
								<input
									type="text"
									className="input input-bordered"
									value={medUniqId}
									onChange={(e) => setMedUniqId(e.target.value)}
									required
								/>
							</div>
							<div className="form-control">
								<label className="label">First Name</label>
								<input
									type="text"
									className="input input-bordered"
									value={firstName}
									onChange={(e) => setFirstName(e.target.value)}
									required
								/>
							</div>
							<div className="form-control">
								<label className="label">Last Name</label>
								<input
									type="text"
									className="input input-bordered"
									value={lastName}
									onChange={(e) => setLastName(e.target.value)}
									required
								/>
							</div>
							<div className="form-control">
								<label className="label">Date of Birth</label>
								<input
									type="date"
									className="input input-bordered"
									value={dob}
									onChange={(e) => setDob(e.target.value)}
									required
								/>
							</div>
							<div className="form-control">
								<label className="label">Sex</label>
								<select
									className="select select-bordered"
									value={sex}
									onChange={(e) => setSex(e.target.value)}
									required
								>
									<option value="">Select</option>
									<option value="M">Male</option>
									<option value="F">Female</option>
									<option value="O">Other</option>
									<option value="U">Unknown</option>
								</select>
							</div>
							<div className="form-control">
								<label className="label">Mobile Number</label>
								<input
									type="text"
									className="input input-bordered"
									value={mobileNumber}
									onChange={(e) => setMobileNumber(e.target.value)}
								/>
							</div>
						</>
					) : (
						<>
							<div className="col-span-2">
								<p>
									<strong>First Name:</strong> {enrollee?.first_name}
								</p>
								<p>
									<strong>Last Name:</strong> {enrollee?.last_name}
								</p>
								<p>
									<strong>Date of Birth:</strong> {enrollee?.dob}
								</p>
								<p>
									<strong>Email:</strong> {enrollee?.email}
								</p>
								<p>
									<strong>Sex:</strong> {enrollee?.sex}
								</p>
							</div>
							<div className="col-span-4">
								<p>
									<strong>Member ID:</strong> {enrollee?.medicaid_unique_id}
								</p>
								<p>
									<strong>Address:</strong> {enrollee?.address_1}{' '}
									{enrollee?.address_2}
								</p>
								<p>
									<strong>City:</strong> {enrollee?.city}
								</p>
								<p>
									<strong>State:</strong> {enrollee?.state}
								</p>
								<p>
									<strong>ZIP:</strong> {enrollee?.postal_code}
								</p>
								<p>
									<strong>Mobile Number:</strong> {enrollee?.mobile_number}
								</p>
							</div>
						</>
					)}
				</div>
				<div className="modal-action">
					<form method="dialog" onSubmit={onClose}>
						{isEmpty(enrollee) ? (
							<>
								<button className="mr-4 btn btn-secondary">Cancel</button>
								<button
									className="btn btn-primary"
									onClick={handleAddEnrollee}
									disabled={
										isEmpty(medUniqId) ||
										isEmpty(firstName) ||
										isEmpty(lastName) ||
										isEmpty(dob) ||
										isEmpty(sex) ||
										isEmpty(mobileNumber)
									}
								>
									Save Enrollee
								</button>
							</>
						) : (
							<button className="btn btn-primary">Close</button>
						)}
					</form>
				</div>
			</div>
		</dialog>
	);
};

EnrolleeModal.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	enrollee: PropTypes.object,
	onClose: PropTypes.func.isRequired,
	onAddEnrollee: PropTypes.func,
};

export default EnrolleeModal;
